import { IMonTinChi } from "../../model/respone/lop-tin-chi/IMonTinChi";
import { apiClient } from "../apiClient";

const MON_TIN_CHI_API = "mon-tin-chi";
export const monTinChiApi = {
    Update: (payload: IMonTinChi) => apiClient.put(`${MON_TIN_CHI_API}`, payload),
}